
<main>
    <router-view />
</main>
